import { jsx, jsxs } from "react/jsx-runtime";
const ProductName = ({
  prefix = "",
  productNameHeadingTag = "div",
  name,
  children
}) => {
  if (!name) return null;
  const HeadingTag = productNameHeadingTag;
  return /* @__PURE__ */ jsxs(HeadingTag, { className: `${prefix}price-module__name`, children: [
    /* @__PURE__ */ jsx("span", { className: `${prefix}price-module__name-decorator notranslate`, children: name }),
    " ",
    children
  ] });
};
var ProductName_default = ProductName;
export {
  ProductName,
  ProductName_default as default
};
